import { productTaxonomyDisplayOptions } from '@/configuration/pages/ConfigurationPage/ExtrasConfiguration/TryOnWidgetConfigurationPage/constants'

export const getEditPreferencesPayload = ({
  backgroundColor,
  textColor,
  buttonColor,
  buttonHoverColor,
  productTaxonomyType,
  productTaxonomyDisplay,
  productTaxonomyIds,
}) => {
  return {
    background_color: backgroundColor,
    text_color: textColor,
    button_color: buttonColor,
    button_hover_color: buttonHoverColor,
    product_taxonomy_type: productTaxonomyType,
    product_taxonomy_display: productTaxonomyDisplay,
    product_taxonomy_ids: productTaxonomyDisplay === productTaxonomyDisplayOptions.all ? [] : productTaxonomyIds,
  }
}
